import { type FC, memo, useCallback, useEffect, useState } from 'react';

import type { GameV1 } from '@/api/games';
import { ButtonHeart } from '@/components/buttons';
import { useGetCommonStore } from '@/store';

interface IHeartButtonProps extends Pick<GameV1, 'real'> {
  isFavorite: boolean;
}

export const HeartButton: FC<IHeartButtonProps> = memo(
  ({ real, isFavorite }) => {
    const useCommonStore = useGetCommonStore();

    const addFavoriteGame = useCommonStore.use.addFavoriteGame();
    const removeFavoriteGame = useCommonStore.use.removeFavoriteGame();

    const [isLoading, setIsLoading] = useState(false);
    const [isActive, setIsActive] = useState(isFavorite);

    useEffect(() => setIsActive(isFavorite), [isFavorite]);

    const handleHeartClick = useCallback(() => {
      setIsLoading(true);
      setIsActive((s) => !s);
      if (isActive) {
        removeFavoriteGame(real).finally(() => {
          setIsLoading(false);
        });
      } else {
        addFavoriteGame(real).finally(() => {
          setIsLoading(false);
        });
      }
    }, [isActive, real, addFavoriteGame, removeFavoriteGame]);

    return (
      <ButtonHeart
        active={isActive}
        disabled={isLoading}
        height={24}
        onClick={handleHeartClick}
        right={4}
        top={4}
        width={24}
      />
    );
  }
);
